module.exports = __webpack_public_path__ + "static/media/videofx_room-control.0abecffb.png";